import { RouteConfig } from "vue-router";

export const REmployerServicesCandidates: RouteConfig = {
  path: "candidates",
  name: "EmployerServicesCandidates",
  component: () =>
    import(
      /* webpackChunkName: "employer-services-candidates" */
      "./VEmployerServicesCandidates.vue"
    ),
  meta: {
    title: "Select a candidate for the new visa application",
    backLink: "/services",
  },
};
